





















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { LatestNewsCollection } from '@/modules/news/models/news-collection.model'
import NewsForm from '@/modules/news/components/admin/NewsForm.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { NewsCreateUseCase } from '@/modules/news/use-cases/admin/news-create.use-case'
import { LatestNewsCategory } from '@/modules/news/models/news-resource.model'

@Component({
  components: { NewsForm, BaseButton }
})
export default class NewsCreate extends Vue {
  constructor(
    private readonly useCase: NewsCreateUseCase
  ) {
    super()
  }

  private newsItem!: LatestNewsCollection
  private createNewsBtnLabel: string = 'ثبت خبر جدید'
  private needClearForm: boolean = false

  data() {
    return {
      newsItem: {
        id: 0,
        title: '',
        url: '',
        lead: '',
        created_at: new Date(),
        updated_at: new Date(),
        category: LatestNewsCategory.CONTENT,
        image_src: ''
      }
    }
  }

  createNews() {
    this.useCase.execute(this.newsItem).then(() => {
      if (this.useCase.isSuccess) this.needClearForm = true //clear form flag
    })
  }

}
